import { render, staticRenderFns } from "./g-room-list.vue?vue&type=template&id=3bcd3d4e&scoped=true"
import script from "./g-room-list.vue?vue&type=script&lang=ts"
export * from "./g-room-list.vue?vue&type=script&lang=ts"
import style0 from "./g-room-list.vue?vue&type=style&index=0&id=3bcd3d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd3d4e",
  null
  
)

export default component.exports